import { render } from "./Item.vue?vue&type=template&id=64efa428&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=64efa428&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64efa428"

export default script